import React from 'react';

const PageLoader = () => {


  return (

              <div id="pageloader" class="central-text">

              <img class="invert" src="/media/image/icons/loader.gif" />

          </div>

  );
};

export default PageLoader;